const $03718d3379a37d9e$export$97361b7a0c542045 = 64;
const $03718d3379a37d9e$export$50c4b2cb40626bcd = 30;
const $03718d3379a37d9e$export$192a7a08b79ef34c = 0.05;
const $03718d3379a37d9e$export$921e43b4923aabc4 = 5;
const $03718d3379a37d9e$export$14ad19da9d4619ba = 0.05;
const $03718d3379a37d9e$export$c278973b89afb67b = 400;
const $03718d3379a37d9e$export$19a33b598d1e243f = 2000;



class $eafb6fe9b39faa42$export$67b4d75f32bb288e extends HTMLElement {
    constructor(score){
        super();
        this.innerHTML = `
      <h1>Game Over</h1>
      <div>
        <div><span>Score:</span><b>${score.count}</b></div>
        <div><span>Time:</span><b>${score.time}</b></div>
        <div><span>Highscore:</span><b>${score.highscore}</b></div>
      </div>
      <a href="/">Play Again</a>
    `;
        document.body.append(this);
    }
}
customElements.define("endscreen-element", $eafb6fe9b39faa42$export$67b4d75f32bb288e);


class $498ab83f206c79df$export$c977b3e384af9ae1 {
    x;
    y;
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    static randomAngle() {
        return $498ab83f206c79df$export$c977b3e384af9ae1.angle(Math.random() * Math.PI * 2);
    }
    static angle(rad) {
        return new $498ab83f206c79df$export$c977b3e384af9ae1(Math.cos(rad), Math.sin(rad));
    }
    static from({ x: x, y: y }) {
        return new $498ab83f206c79df$export$c977b3e384af9ae1(x, y);
    }
    angle() {
        const magnitude = this.magnitude();
        if (magnitude === 0) return 0;
        return Math.acos(this.x / magnitude);
    }
    magnitude() {
        return Math.sqrt(this.x ** 2 + this.y ** 2);
    }
    distance(other) {
        return this.sub(other).magnitude();
    }
    unit() {
        return this.div(this.magnitude());
    }
    add({ x: x, y: y }) {
        return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x + x, this.y + y);
    }
    sub({ x: x, y: y }) {
        return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x - x, this.y - y);
    }
    mul(obj) {
        if (typeof obj === "object") return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x * obj.x, this.y * obj.y);
        else return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x * obj, this.y * obj);
    }
    div(obj) {
        if (typeof obj === "object") return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x / obj.x, this.y / obj.y);
        else if (obj === 0) return new $498ab83f206c79df$export$c977b3e384af9ae1();
        else return new $498ab83f206c79df$export$c977b3e384af9ae1(this.x / obj, this.y / obj);
    }
}


class $9447aa84e0195f00$export$bc644a473284d944 extends EventTarget {
    group = null;
    position = new (0, $498ab83f206c79df$export$c977b3e384af9ae1)();
    radius = 0.5;
    angle = 0;
    color = "#fff4";
    text = "#";
    angle_velocity = 0;
    velocity = new (0, $498ab83f206c79df$export$c977b3e384af9ae1)();
    forces = {};
    clone() {
        return Object.assign(new $9447aa84e0195f00$export$bc644a473284d944(), this, {
            position: (0, $498ab83f206c79df$export$c977b3e384af9ae1).from(this.position),
            velocity: (0, $498ab83f206c79df$export$c977b3e384af9ae1).from(this.velocity),
            forces: {}
        });
    }
}


const $9854e5c3ea7d3d94$export$16e4d70cc375e707 = {
    keys: new Set(),
    get space () {
        return $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(32);
    },
    get left () {
        return $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(37) || $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(65);
    },
    get up () {
        return $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(38) || $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(87);
    },
    get right () {
        return $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(39) || $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(68);
    },
    get down () {
        return $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(40) || $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.has(83);
    },
    get x () {
        return Number($9854e5c3ea7d3d94$export$16e4d70cc375e707.right) - Number($9854e5c3ea7d3d94$export$16e4d70cc375e707.left);
    },
    get y () {
        return Number($9854e5c3ea7d3d94$export$16e4d70cc375e707.up) - Number($9854e5c3ea7d3d94$export$16e4d70cc375e707.down);
    }
};
addEventListener("keydown", ({ keyCode: keyCode })=>{
    $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.add(keyCode);
});
addEventListener("keyup", ({ keyCode: keyCode })=>{
    $9854e5c3ea7d3d94$export$16e4d70cc375e707.keys.delete(keyCode);
});




class $586c447b673422ec$export$738d7c27844ed173 extends AbortController {
    model;
    game;
    interval;
    last_bullet;
    constructor(model, game){
        super();
        this.model = model;
        this.game = game;
        this.last_bullet = 0;
        this.interval = setInterval(this.step.bind(this), 1000 / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd));
    }
    step() {
        this.updateControl();
        this.updateDrag();
        this.shoot();
    }
    updateControl() {
        this.model.angle_velocity = (0, $9854e5c3ea7d3d94$export$16e4d70cc375e707).x * -0.1;
        this.model.forces.control = (0, $498ab83f206c79df$export$c977b3e384af9ae1).angle(this.model.angle).mul((0, $9854e5c3ea7d3d94$export$16e4d70cc375e707).y);
    }
    updateDrag() {
        const { velocity: velocity, forces: forces } = this.model;
        const drag = new (0, $498ab83f206c79df$export$c977b3e384af9ae1)();
        if (Math.abs(velocity.x) < 0.01) velocity.x = drag.x = 0;
        else if (velocity.x < 0) drag.x = (0, $03718d3379a37d9e$export$192a7a08b79ef34c);
        else drag.x = -(0, $03718d3379a37d9e$export$192a7a08b79ef34c);
        if (Math.abs(velocity.y) < 0.01) velocity.y = drag.y = 0;
        else if (velocity.y < 0) drag.y = (0, $03718d3379a37d9e$export$192a7a08b79ef34c);
        else drag.y = -(0, $03718d3379a37d9e$export$192a7a08b79ef34c);
        forces.drag = drag;
    }
    shoot() {
        if (!(0, $9854e5c3ea7d3d94$export$16e4d70cc375e707).space) return;
        if (Date.now() - this.last_bullet < (0, $03718d3379a37d9e$export$c278973b89afb67b)) return;
        this.last_bullet = Date.now();
        this.game.createBullet();
    }
    abort() {
        super.abort();
        clearInterval(this.interval);
    }
}




class $b84ea07011828d87$export$966f331c7e366cb5 extends HTMLElement {
    model;
    constructor(model){
        super();
        this.model = model;
    }
    render() {
        this.style.setProperty("--x", this.model.position.x.toString());
        this.style.setProperty("--y", this.model.position.y.toString());
        this.style.setProperty("--angle", this.model.angle.toString());
        this.style.setProperty("--color", this.model.color);
        this.style.setProperty("--radius", this.model.radius.toString());
        this.style.setProperty("--text", `"${this.model.text}"`);
    }
}
customElements.define("entity-element", $b84ea07011828d87$export$966f331c7e366cb5);


class $f1a40faa78a338fe$export$bdfe8f3b7ffd9a01 extends AbortController {
    entities;
    elements;
    interval;
    constructor(entities){
        super();
        this.entities = entities;
        this.elements = new Map();
        requestAnimationFrame(this.render.bind(this));
        this.interval = setInterval(this.step.bind(this), 1000 / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd));
    }
    abort() {
        super.abort();
        clearInterval(this.interval);
        for (const element of this.elements.values())element.remove();
    }
    render() {
        if (this.signal.aborted) return;
        requestAnimationFrame(this.render.bind(this));
        for (const element of this.elements.values())element.render();
    }
    step() {
        this.createElements();
        this.deleteElements();
    }
    createElements() {
        for (const entity of this.entities){
            if (this.elements.has(entity)) continue;
            const element = new (0, $b84ea07011828d87$export$966f331c7e366cb5)(entity);
            document.body.append(element);
            this.elements.set(entity, element);
        }
    }
    deleteElements() {
        for (const [entity, element] of this.elements){
            if (this.entities.has(entity)) continue;
            element.remove();
            this.elements.delete(entity);
        }
    }
}


class $a83aadae35e23f79$export$f3e1469e961b7488 extends Event {
    target;
    other;
    constructor(target, other){
        super("collision");
        this.target = target;
        this.other = other;
    }
}



class $aa3ab1d0ad248527$export$3da23c0875a46dd7 extends AbortController {
    entities;
    interval;
    constructor(entities){
        super();
        this.entities = entities;
        this.interval = setInterval(this.step.bind(this), 1000 / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd));
    }
    abort() {
        super.abort();
        clearInterval(this.interval);
    }
    step() {
        for (const entity of this.entities)this.updateEntity(entity);
        for (const entity of this.entities)this.checkCollisions(entity);
    }
    updateEntity(entity) {
        this.applyForces(entity);
        this.clipVelocity(entity);
        this.applyVelocity(entity);
        this.wrapPosition(entity);
    }
    applyForces(entity) {
        for (const force of Object.values(entity.forces)){
            entity.velocity.x += force.x / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd);
            entity.velocity.y += force.y / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd);
        }
    }
    clipVelocity(entity) {
        const { x: x, y: y } = entity.velocity;
        const termvel = (0, $03718d3379a37d9e$export$921e43b4923aabc4) / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd);
        entity.velocity.x = Math.max(-termvel, Math.min(x, termvel));
        entity.velocity.y = Math.max(-termvel, Math.min(y, termvel));
    }
    applyVelocity(entity) {
        entity.position.x += entity.velocity.x;
        entity.position.y += entity.velocity.y;
        entity.angle += entity.angle_velocity;
    }
    wrapPosition(entity) {
        const { position: position } = entity;
        const width = innerWidth / (0, $03718d3379a37d9e$export$97361b7a0c542045);
        if (position.x > width / 2) position.x -= width;
        else if (position.x < -width / 2) position.x += width;
        const height = innerHeight / (0, $03718d3379a37d9e$export$97361b7a0c542045);
        if (position.y > height / 2) position.y -= height;
        else if (position.y < -height / 2) position.y += height;
    }
    checkCollisions(entity) {
        for (const other of this.entities){
            if (other === entity) continue;
            if (!this.collides(entity, other)) continue;
            entity.dispatchEvent(new (0, $a83aadae35e23f79$export$f3e1469e961b7488)(entity, other));
            entity.velocity = entity.position.sub(other.position).unit().mul((0, $03718d3379a37d9e$export$14ad19da9d4619ba));
        }
    }
    collides(a, b) {
        const distance = a.position.distance(b.position);
        return distance < a.radius + b.radius;
    }
}


class $077c19fafb7ad227$export$b78ced84367f0778 extends Set {
    groups = {};
    add(entity) {
        super.add(entity);
        const { group: group } = entity;
        if (!group) return this;
        if (!this.groups[group]) this.groups[group] = new Set();
        this.groups[group].add(entity);
        return this;
    }
    delete(entity) {
        const did_exist = super.delete(entity);
        const { group: group } = entity;
        if (group) this.groups[group]?.delete(entity);
        return did_exist;
    }
}


class $b5c73b2e44561771$export$680ea196effce5f {
    value;
    constructor(value){
        this.value = value;
    }
    toString() {
        const minutes = this.getMinutes().toString().padStart(2, "0");
        const seconds = this.getSeconds().toString().padStart(2, "0");
        const millis = this.getMillis().toString().padStart(3, "0");
        return `${minutes}:${seconds}.${millis}`;
    }
    getMillis() {
        return this.value % 1000;
    }
    getSeconds() {
        return Math.floor(this.value / 1000) % 60;
    }
    getMinutes() {
        return Math.floor(this.value / 1000 / 60);
    }
}


class $1ba1dc4f3ad8f67f$export$6735cf84ecd2736 {
    count = 0;
    start = Date.now();
    end = 0;
    highscore = 0;
    constructor(){
        this.load();
    }
    get time() {
        const delta = (this.end || Date.now()) - this.start;
        return new (0, $b5c73b2e44561771$export$680ea196effce5f)(delta);
    }
    save() {
        this.end = Date.now();
        if (this.count > this.highscore) {
            localStorage.setItem("highscore", this.count.toString());
            this.load();
        }
    }
    load() {
        const highscore = localStorage.getItem("highscore");
        if (highscore) this.highscore = Number(highscore);
    }
}



class $a873c7aae39d958b$export$4ef648400150f28a extends HTMLElement {
    model;
    left;
    center;
    right;
    constructor(model){
        super();
        this.model = model;
        this.left = document.createElement("div");
        this.center = document.createElement("div");
        this.right = document.createElement("div");
        this.append(this.left, this.center, this.right);
        document.body.append(this);
        this.render();
    }
    render() {
        if (this.parentNode) requestAnimationFrame(this.render.bind(this));
        this.left.innerText = `Highscore: ${this.model.highscore}`;
        this.center.innerText = `Score: ${this.model.count}`;
        this.right.innerText = this.model.time.toString();
    }
}
customElements.define("score-element", $a873c7aae39d958b$export$4ef648400150f28a);



class $963a690f33560800$export$985739bfa5723e08 extends AbortController {
    entities = new (0, $077c19fafb7ad227$export$b78ced84367f0778)();
    runner = new (0, $aa3ab1d0ad248527$export$3da23c0875a46dd7)(this.entities);
    renderer = new (0, $f1a40faa78a338fe$export$bdfe8f3b7ffd9a01)(this.entities);
    player = new (0, $9447aa84e0195f00$export$bc644a473284d944)();
    controller = new (0, $586c447b673422ec$export$738d7c27844ed173)(this.player, this);
    score = new (0, $1ba1dc4f3ad8f67f$export$6735cf84ecd2736)();
    score_element = new (0, $a873c7aae39d958b$export$4ef648400150f28a)(this.score);
    interval;
    constructor(){
        super();
        this.player.color = "#f0f8";
        this.player.text = ">";
        this.player.angle = Math.PI / 2;
        this.player.addEventListener("collision", this.endscreen.bind(this), this);
        this.entities.add(this.player);
        this.interval = setInterval(this.step.bind(this), 1000 / (0, $03718d3379a37d9e$export$50c4b2cb40626bcd));
    }
    endscreen() {
        this.runner.abort();
        this.controller.abort();
        this.score.save();
        new (0, $eafb6fe9b39faa42$export$67b4d75f32bb288e)(this.score);
    }
    createBullet() {
        const bullet = new (0, $9447aa84e0195f00$export$bc644a473284d944)();
        bullet.text = "=";
        bullet.radius = 0.2;
        bullet.color = "#0008";
        const angle_vector = (0, $498ab83f206c79df$export$c977b3e384af9ae1).angle(this.player.angle);
        bullet.position = this.player.position.add(angle_vector);
        bullet.angle = this.player.angle;
        bullet.velocity = (0, $498ab83f206c79df$export$c977b3e384af9ae1).angle(this.player.angle).mul(0.2);
        bullet.addEventListener("collision", this.bulletHit.bind(this), this);
        this.entities.add(bullet);
        setTimeout(()=>this.entities.delete(bullet), (0, $03718d3379a37d9e$export$19a33b598d1e243f));
    }
    bulletHit({ target: target, other: other }) {
        this.score.count++;
        this.entities.delete(target);
        this.entities.delete(other);
        const split_angle = other.position.sub(target.position).angle() - Math.PI / 2;
        if (other.radius > 0.7) {
            const a = other.clone();
            const b = other.clone();
            a.position = a.position.add((0, $498ab83f206c79df$export$c977b3e384af9ae1).angle(split_angle).mul(0.1));
            b.position = b.position.add((0, $498ab83f206c79df$export$c977b3e384af9ae1).angle(split_angle).mul(-0.1));
            a.radius = b.radius = other.radius * 0.6;
            this.entities.add(a);
            this.entities.add(b);
        }
    }
    step() {
        this.createRocks();
    }
    createRocks() {
        for(let i = this.entities.groups.rocks?.size || 0; i < 10; i++)this.createRock();
    }
    createRock() {
        const entity = new (0, $9447aa84e0195f00$export$bc644a473284d944)();
        const distance = 5 + Math.random() * 5;
        const speed = Math.random() * 0.1;
        const delta = (0, $498ab83f206c79df$export$c977b3e384af9ae1).randomAngle().mul(distance);
        entity.position = this.player.position.add(delta);
        entity.angle_velocity = (Math.random() - 0.5) * 0.1;
        entity.velocity = (0, $498ab83f206c79df$export$c977b3e384af9ae1).randomAngle().mul(speed);
        entity.radius = 0.5 + Math.random() * 0.7;
        entity.group = "rocks";
        this.entities.add(entity);
    }
    abort() {
        super.abort();
        this.runner.abort();
        this.renderer.abort();
        clearInterval(this.interval);
    }
}


new (0, $963a690f33560800$export$985739bfa5723e08)();


//# sourceMappingURL=index.c0a24ad8.js.map
